/**
 * 数学计算相关常量配置（全局只读）
 *
 * ROUND: 正常四舍五入
 *  - 取值：0
 *  - 示例：1.354保留两位是1.35；1.355保留两位是1.36
 *
 * ROUND_FLOOR: 向下舍出
 *  - 取值：1
 *  - 示例：1.354保留两位是1.35；1.355保留两位是1.35
 */
export const MATH: Record<string, any> = {
  // 正常四舍五入，如：1.354保留两位是1.35；1.355保留两位是1.36；
  ROUND: 0,
  // 向下舍出，如：1.354保留两位是1.35；1.355保留两位是1.35；
  ROUND_FLOOR: 1,
} as const;
